import api from '../../api'

export default {
    // this one only get the latest set of dashboards without the config
    async sync({ commit }) {
        // var dashboardLookups = await api.dashboard.fetchDashboards()
        // commit('SET_DASHBOARD_TYPES', dashboardLookups)
    },
    async createNewDashboard({ dispatch }, { id, type, name }) {
        // this may result in a temporary mismatch between server and client
        var dashboard = {
            id: id || window.generateGuid(),
            name,
            type,
            widgets: []
        }
        await dispatch('saveDashboard', dashboard)
        return dashboard
    },
    // fetch every time the user clicks on a dashboard
    async fetchDashboard({ commit, getters }, id) {
        if (!id) {
            return Promise.resolve(null)
        }

        // var dashboardPacket = await api.dashboard.fetchDashboardById(id)
        // var dashboardPacket =
        // {
        //     id: '5da5bd80-6488-4e76-a36d-f165b3991168',
        //     name: 'New Dashboard',
        //     type: 'CRM',
        //     widgetsJson: [
        //         {
        //             i: 'e18d6c0a-a785-4cfe-b97a-951a4961d0ae',
        //             w: 18,
        //             h: 3,
        //             x: 16,
        //             y: 0,
        //             isResizable: true,
        //             component: 'patient-lookup-widget',
        //             config: {},
        //             moved: false
        //         }
        //     ]
        // }
        // var dashboard = {
        //     ...dashboardPacket,
        //     // widgets: JSON.parse(dashboardPacket.widgetsJson)
        //     widgets: dashboardPacket.widgetsJson
        // }
        // debugger
        // commit('SAVE_DASHBOARD', dashboard)
        return getters.getDashboardById(id)
    },
    async saveDashboard({ commit }, dashboard) {
        // await api.dashboard.saveDashboard(dashboard)

        commit('SAVE_DASHBOARD', dashboard)
    }
}
